module.exports = __webpack_public_path__ + "static/media/services_solarium2.6958ad70.jpg";